import { render, staticRenderFns } from "./AddStudentByExcelDialog.vue?vue&type=template&id=c2fade2a&scoped=true"
import script from "./AddStudentByExcelDialog.vue?vue&type=script&lang=js"
export * from "./AddStudentByExcelDialog.vue?vue&type=script&lang=js"
import style0 from "./AddStudentByExcelDialog.vue?vue&type=style&index=0&id=c2fade2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fade2a",
  null
  
)

export default component.exports